import { render, staticRenderFns } from "./message-plugin-web.vue?vue&type=template&id=19f84168&scoped=true"
import script from "./message-plugin-web.vue?vue&type=script&lang=ts"
export * from "./message-plugin-web.vue?vue&type=script&lang=ts"
import style0 from "./message-plugin-web.vue?vue&type=style&index=0&id=19f84168&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f84168",
  null
  
)

export default component.exports